const ConnectShopifyStoreVerifyPage = () => <div className={"dashboard-page"} />

export default ConnectShopifyStoreVerifyPage
